<template>
  <ins
    class="adsbygoogle"
    :style="adStyle"
    :data-ad-client="adClient"
    :data-ad-slot="adSlot || 4357125401"
    :data-ad-format="adFormat || 'auto'"
    :data-full-width-responsive="fullWidth ?? true"
    v-bind="{
      ...(adLayoutKey ? { 'data-ad-layout-key': adLayoutKey } : {}),
    }"
  />
</template>

<script setup lang="ts">
const {
  adSlot = '4357125401',
  adFormat = 'auto',
  adStyle = 'display:block',
  fullWidth = 'auto',
  adLayoutKey = '',
} = defineProps<{
  adSlot?: string;
  adFormat?: string;
  adStyle?: string;
  fullWidth?: string;
  adLayoutKey?: string;
}>();

const config = useRuntimeConfig();
const adClient = config.public.adsense || 'ca-pub-8104818500522443';

onMounted(() => {
  try {
    (window.adsbygoogle = window.adsbygoogle || []).push({});
  } catch (e) {
    console.error('AdSense error:', e);
  }
});
</script>
